// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.spotlight.RentalManagerUserPropertySpotlightWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertySpotlightWebApiHandler_apply,
  RentalManagerUserPropertySpotlightWebApiHandler_exclude,
  RentalManagerUserPropertySpotlightWebApiHandler_excludeListings,
  RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig,
  RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_list,
  RentalManagerUserPropertySpotlightWebApiHandler_list_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_overview,
  RentalManagerUserPropertySpotlightWebApiHandler_overview_Path,
  RentalManagerUserPropertySpotlightWebApiHandler_pin,
  RentalManagerUserPropertySpotlightWebApiHandler_pinListings,
  RentalManagerUserPropertySpotlightWebApiHandler_reassign,
  RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization,
  RentalManagerUserPropertySpotlightWebApiHandler_remove,
  RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled,
  RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode,
  RentalManagerUserPropertySpotlightWebApiHandler_unexclude,
  RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings,
  RentalManagerUserPropertySpotlightWebApiHandler_unpin,
  RentalManagerUserPropertySpotlightWebApiHandler_unpinListings,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  BulkListingSpotlightRequestDto,
  CustomerListingSpotlightOptimizationConfigDto,
  GetSpotlightedListingsResponseDto,
  GetUserPropertySpotlightOverviewResponseDto,
  ListingAlias,
  ListingSpotlightUpdateResultDto,
  SetAutoOptimizeEnabledRequestDto,
  SetOptimizationModeRequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface ApplyParams {
  listingAlias: ListingAlias;
}
interface ExcludeParams {
  listingAlias: ListingAlias;
}
interface PinParams {
  listingAlias: ListingAlias;
}
interface ReassignParams {
  fromListingAlias: ListingAlias;
  toListingAlias: ListingAlias;
}
interface ReassignWithOptimizationParams {
  fromListingAlias: ListingAlias;
  toListingAlias: ListingAlias;
}
interface RemoveParams {
  listingAlias: ListingAlias;
}
interface UnexcludeParams {
  listingAlias: ListingAlias;
}
interface UnpinParams {
  listingAlias: ListingAlias;
}

export interface RentalManagerUserPropertySpotlightWebApiHandler_apply_Args {
  getParams: ApplyParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_apply_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_apply_Args
>;

/**
 * Apply listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_apply = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_apply_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_apply_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_apply(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_exclude_Args {
  getParams: ExcludeParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_exclude_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_exclude_Args
>;

/**
 * Exclude listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_exclude = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_exclude_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_exclude_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_exclude(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Args
>;

/**
 * Exclude listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_excludeListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_excludeListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_excludeListings(args.postData, httpClient),
  });
};

export type RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Options = UseQueryOptions<
  CustomerListingSpotlightOptimizationConfigDto,
  unknown,
  CustomerListingSpotlightOptimizationConfigDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get optimization config for spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_getOptimizationConfig_GetKey;

export type RentalManagerUserPropertySpotlightWebApiHandler_list_Options = UseQueryOptions<
  GetSpotlightedListingsResponseDto,
  unknown,
  GetSpotlightedListingsResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_list_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_list_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_list(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get listings with spotlight promotion
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_list = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_list_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_list_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_list.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_list_GetKey;

export type RentalManagerUserPropertySpotlightWebApiHandler_overview_Options = UseQueryOptions<
  GetUserPropertySpotlightOverviewResponseDto,
  unknown,
  GetUserPropertySpotlightOverviewResponseDto,
  readonly [string]
>;

const RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey = () =>
  [RentalManagerUserPropertySpotlightWebApiHandler_overview_Path] as const;

export const RentalManagerUserPropertySpotlightWebApiHandler_overview_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey(),
    queryFn: () => RentalManagerUserPropertySpotlightWebApiHandler_overview(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get spotlight overview for user properties
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_overview = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_overview_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerUserPropertySpotlightWebApiHandler_overview_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertySpotlightWebApiHandler_overview.getKey =
  RentalManagerUserPropertySpotlightWebApiHandler_overview_GetKey;

export interface RentalManagerUserPropertySpotlightWebApiHandler_pin_Args {
  getParams: PinParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_pin_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_pin_Args
>;

/**
 * Pin listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_pin = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_pin_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_pin_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_pin(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Args
>;

/**
 * Pin listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_pinListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_pinListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_pinListings(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_reassign_Args {
  getParams: ReassignParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_reassign_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_reassign_Args
>;

/**
 * Reassign listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_reassign = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_reassign_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_reassign_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_reassign(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Args {
  getParams: ReassignWithOptimizationParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Args
>;

/**
 * Reassign listing spotlight with optimization
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_reassignWithOptimization(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_remove_Args {
  getParams: RemoveParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_remove_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_remove_Args
>;

/**
 * Remove listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_remove = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_remove_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_remove_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_remove(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled_Args {
  postData: SetAutoOptimizeEnabledRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled_Args
>;

/**
 * Set auto-optimize enabled for spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_setAutoOptimizeEnabled(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Args {
  postData: SetOptimizationModeRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Args
>;

/**
 * Set optimization mode for spotlight
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_setOptimizationMode(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Args {
  getParams: UnexcludeParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Args
>;

/**
 * Unexclude listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_unexclude = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_unexclude_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_unexclude(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Args
>;

/**
 * Unexclude listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_unexcludeListings(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_unpin_Args {
  getParams: UnpinParams;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_unpin_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_unpin_Args
>;

/**
 * Unpin listing spotlight
 * @deprecated
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_unpin = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_unpin_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_unpin_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_unpin(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Args {
  postData: BulkListingSpotlightRequestDto;
}

export type RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Options = UseMutationOptions<
  Array<ListingSpotlightUpdateResultDto>,
  unknown,
  RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Args
>;

/**
 * Unpin listing spotlight for listings
 */
export const useRentalManagerUserPropertySpotlightWebApiHandler_unpinListings = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpotlightWebApiHandler_unpinListings_Args) =>
      RentalManagerUserPropertySpotlightWebApiHandler_unpinListings(args.postData, httpClient),
  });
};
